import React, { useEffect, useRef } from 'react';
import { FaQuestion } from 'react-icons/fa';
import MDEditor from '@uiw/react-md-editor';
import { mathPlugins } from '../../../utils/markdownMath';
import AnswerMarkdown from '../../common/AnswerMarkdown';

const AUTO_ADVANCE_SEC = 2;

const Pitanje = ({ currentQuestion, progressBar, handleAnswer, isAnswered, onReturnToPiramida, duration, takmicarski, zavrsnoPitanje }: any) => {
    const autoAdvanceBar = useRef<any>(null);
    const autoAdvanceTimer = useRef<any>(null);

    useEffect(() => {
        if (isAnswered && takmicarski && !zavrsnoPitanje) {
            if (autoAdvanceBar.current) {
                autoAdvanceBar.current.classList.remove('active');
                // force reflow da animacija krene ispočetka
                void autoAdvanceBar.current.offsetWidth;
                autoAdvanceBar.current.classList.add('active');
            }
            autoAdvanceTimer.current = setTimeout(() => {
                onReturnToPiramida();
            }, AUTO_ADVANCE_SEC * 1000);
        }
        return () => {
            if (autoAdvanceTimer.current) clearTimeout(autoAdvanceTimer.current);
        };
    }, [isAnswered, takmicarski, zavrsnoPitanje]);

    return (
        <div className=" pb-5 px-3 md:px-20 w-full flex flex-col items-center bg-white rounded-[10px]">
            {/* Progress bar */}
            <div className="mt-5 px-3 w-full">
                <div className="progress-container">
                    <div className="progress-bar active" ref={progressBar} style={{ animationDuration: `${duration}s` }}></div>
                </div>
            </div>
            {/* Pitanje */}
            <div className="flex flex-row items-center gap-2 mt-5  w-full max-w-[450px] ">
                <div className="h-[60px] min-w-[60px] border border-blueMedium rounded-full justify-center items-center flex">
                    <FaQuestion size={35} color="#234b98" />
                </div>
                <MDEditor.Markdown {...mathPlugins} className="test-znanja-naziv" source={currentQuestion?.naziv} />
            </div>

            <div className="h-[1px] w-full max-w-[450px] bg-blueMedium mt-5"></div>

            {/* Odgovori */}
            <div className="w-full flex flex-col items-center gap-4 mt-6">
                {currentQuestion?.odgovori?.map((odgovor: any) => {
                    return <Odgovor odgovor={odgovor} handleOdgovor={handleAnswer} key={odgovor?.id} isAnswered={isAnswered} />;
                })}
            </div>

            {/* Dugme za povratak */}
            {isAnswered && !zavrsnoPitanje && (
                <div className="mt-6 flex flex-col items-center gap-2 w-full max-w-[450px]">
                    <button onClick={onReturnToPiramida} className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
                        Vrati se na piramidu
                    </button>
                    {takmicarski && (
                        <div className="progress-container-thin w-full">
                            <div className="progress-bar" ref={autoAdvanceBar} style={{ animationDuration: `${AUTO_ADVANCE_SEC}s` }}></div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Pitanje;

const Odgovor = ({ odgovor, handleOdgovor, isAnswered }: { odgovor: any; handleOdgovor: any; isAnswered: boolean }) => {
    const [selected, setSelected] = React.useState(false);

    const selectOdgovor = (odgovor: any) => {
        setSelected(true);
        handleOdgovor(odgovor);
    };

    useEffect(() => {
        setSelected(false);
    }, [odgovor]);

    return (
        <button
            className={` w-full max-w-[450px] min-h-[50px] ${
                !selected && isAnswered && odgovor.tacan
                    ? 'bg-greenA200'
                    : !selected && isAnswered
                      ? 'bg-blueLight'
                      : !selected
                        ? 'bg-blueLight hover:bg-blueHoverLight'
                        : selected && odgovor.tacan
                          ? 'bg-greenA200'
                          : 'bg-redError'
            } flex flex-row items-center gap-5 px-6 rounded-[15px] transition`}
            onClick={() => selectOdgovor(odgovor)}
            disabled={isAnswered}
        >
            <AnswerMarkdown source={odgovor.text} />
        </button>
    );
};
